export const loginrequest = async (emailInput, passwordInput,lang) => {
  try {
    let data = {};
    const numRegex = /^[0-9]+$/;
    if (numRegex.test(emailInput)) {
      data = {
        mobile: emailInput,
        password: passwordInput,
        lang:lang
      };
    } else {
      data = {
        email: emailInput,
        password: passwordInput,
        lang:lang
      };
    }
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    const res = await fetch(`${process.env.REACT_APP_BASE_URL}/api/login`, {
      headers,
      method: "POST",
      body: JSON.stringify(data),
    });
    return res;
  } catch (error) {}
};
